"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.showDisclaimer = exports.APIsendKeepAlive = exports.APIsendFeedback = exports.APIsendRating = exports.APIsendStat = exports.APIrequestPages = exports.APIrequestPdf = exports.APIsendTask = exports.getCommonData = void 0;
var axios_1 = __importDefault(require("axios"));
var localStorage_1 = require("../localStorage");
var helpers_1 = require("../helpers");
var defaultConfig = {
    baseURL: helpers_1.baseUrl,
    method: 'post',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    withCredentials: false
};
axios_1["default"].interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});
function getCommonData(isMobile) {
    var docId = Number(helpers_1.getDocumentId());
    return {
        mobile: isMobile,
        user_flag: helpers_1.getUserFlag(),
        doc_id: docId,
        user_uuid: localStorage_1.getUserUUID(),
        user_session_uuid: localStorage_1.getSessionUUID(docId)
    };
}
exports.getCommonData = getCommonData;
function APIsendTask(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, axios_1["default"](__assign(__assign({}, defaultConfig), { url: helpers_1.baseUrl + "/task/", data: data })).then(function (response) {
                    if (response.data.status === 'success') {
                        localStorage_1.refreshStorage(response.data);
                    }
                    return response;
                })];
        });
    });
}
exports.APIsendTask = APIsendTask;
/**
 * Checks task completion
 * @param data
 */
function APIrequestPdf(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, axios_1["default"](__assign(__assign({}, defaultConfig), { url: helpers_1.baseUrl + "/check/", data: data })).then(function (response) {
                    if (response.data.status === 'success') {
                        localStorage_1.refreshStorage(response.data);
                    }
                    return response;
                })];
        });
    });
}
exports.APIrequestPdf = APIrequestPdf;
function APIrequestPages(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, axios_1["default"](__assign(__assign({}, defaultConfig), { url: helpers_1.baseUrl + "/doc/", data: data })).then(function (response) {
                    if (response.data.status === 'success') {
                        localStorage_1.refreshStorage(response.data);
                    }
                    return response;
                })];
        });
    });
}
exports.APIrequestPages = APIrequestPages;
function APIsendStat(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, axios_1["default"](__assign(__assign({}, defaultConfig), { url: helpers_1.baseUrl + "/stat/", data: data })).then(function (response) {
                    if (response.data.status === 'success') {
                        localStorage_1.refreshStorage(response.data);
                    }
                    return response;
                })];
        });
    });
}
exports.APIsendStat = APIsendStat;
function APIsendRating(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, axios_1["default"](__assign(__assign({}, defaultConfig), { url: helpers_1.baseUrl + "/rating/", data: data })).then(function (response) {
                    if (response.data.status === 'success') {
                        localStorage_1.refreshStorage(response.data);
                    }
                    return response;
                })];
        });
    });
}
exports.APIsendRating = APIsendRating;
function APIsendFeedback(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, axios_1["default"](__assign(__assign({}, defaultConfig), { url: helpers_1.baseUrl + "/feedback/", data: data })).then(function (response) {
                    if (response.data.status === 'success') {
                        localStorage_1.refreshStorage(response.data);
                    }
                    return response;
                })];
        });
    });
}
exports.APIsendFeedback = APIsendFeedback;
// метод keep-alive срабатывает часто - успокаиваем его
var lastKeepAlive;
var wasKeepAlive = false;
var timerKeepAlive;
var checkKeepAliveTimeout = function (data) {
    var timeout = 30 * 1000;
    if (!lastKeepAlive || Date.now() - lastKeepAlive > timeout) {
        lastKeepAlive = Date.now();
        wasKeepAlive = false;
        clearTimeout(timerKeepAlive);
        return true;
    }
    if (!wasKeepAlive) {
        timerKeepAlive = setTimeout(function () {
            lastKeepAlive = Date.now();
            wasKeepAlive = false;
            sendKeepAlive(data);
        }, timeout);
        wasKeepAlive = true;
    }
    return false;
};
var sendKeepAlive = function (data) {
    return axios_1["default"](__assign(__assign({}, defaultConfig), { url: helpers_1.baseUrl + "/keep-alive/", data: data })).then(function (response) {
        if (response.data.status === 'success') {
            localStorage_1.refreshStorage(response.data);
        }
        return response;
    });
};
function APIsendKeepAlive(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (checkKeepAliveTimeout(data))
                return [2 /*return*/, sendKeepAlive(data)];
            return [2 /*return*/];
        });
    });
}
exports.APIsendKeepAlive = APIsendKeepAlive;
var showDisclaimer = function (cookieDomain) { return __awaiter(void 0, void 0, void 0, function () {
    var euroCountryCodes, response, getCookie, setCookie, countryCode;
    return __generator(this, function (_a) {
        euroCountryCodes = [
            'BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'HR', 'IT', 'CY', 'LV', 'LT',
            'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'UK', 'GB',
        ];
        response = { status: false };
        getCookie = function (name) {
            var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        };
        setCookie = function (name, value, expiresIn) {
            if (expiresIn === void 0) { expiresIn = 365 * 24 * 60 * 60 * 1000; }
            var date = new Date();
            date.setTime(date.getTime() + expiresIn);
            var expires = date.toUTCString();
            document.cookie = name + "=" + value + "; expires=" + expires + ";" + (cookieDomain ? ' domain=templateroller.com;' : '') + " path=/";
            return true;
        };
        if (!!getCookie('was_here_trl'))
            return [2 /*return*/, response];
        try {
            countryCode = window.gc || "";
            if (typeof countryCode !== 'string') {
                return [2 /*return*/, response];
            }
            if (euroCountryCodes.indexOf(countryCode.trim().toUpperCase()) !== -1) {
                response.set = function () { return setCookie('was_here_trl', '1', 60 * 60 * 24 * 30 * 12 * 1000); };
                response.status = 'cookie';
            }
            return [2 /*return*/, response];
        }
        catch (error) {
            return [2 /*return*/, response];
        }
        return [2 /*return*/];
    });
}); };
exports.showDisclaimer = showDisclaimer;
